module.exports = __webpack_public_path__ + "media/images/flextab-logo@2x-7caeedc1806117d68692933c6fab843e.png";